import classnames from 'classnames';
import React from 'react';
import styles from './chatMenuItem.module.scss';

interface ChatMenuItemProps extends React.InputHTMLAttributes<HTMLLIElement> {
  icon?: string;
  text: string;
  action?: JSX.Element;
}

const ChatMenuItem = ({
  icon,
  text,
  action,
  className,
  ...liProps
}: ChatMenuItemProps) => {
  return (
    <li className={classnames(styles.listItem, className)} {...liProps}>
      <div className={styles.left}>
        {icon ? (
          <img src={icon} className={styles.icon} alt="menuItemIcon" />
        ) : null}
        <p>{text}</p>
      </div>
      {action}
    </li>
  );
};
export default ChatMenuItem;
